import type { ColumnDef } from '@tanstack/react-table';
import type { ApiKeySummaryRow } from './types';

const dashIfNullish = (v: unknown): string =>
  v === null || v === undefined || v === '' ? '—' : String(v);

/**
 * Column set shared by the Summary and Historical Summary pages. Both views
 * read the same legacy shape — only the source endpoint differs.
 */
export const SUMMARY_COLUMNS: ColumnDef<ApiKeySummaryRow>[] = [
  {
    accessorKey: 'id',
    header: 'S.No.',
    size: 80,
    cell: ({ row }) => (
      <span className="font-mono text-xs text-muted-foreground">
        {row.original.id}
      </span>
    ),
  },
  { accessorKey: 'userId', header: 'User ID', size: 100 },
  { accessorKey: 'username', header: 'Username', size: 140 },
  { accessorKey: 'parentName', header: 'Parent', size: 140 },
  {
    accessorKey: 'apiKey',
    header: 'API key',
    cell: ({ row }) => (
      <span className="break-all font-mono text-xs">
        {dashIfNullish(row.original.apiKey)}
      </span>
    ),
  },
  { accessorKey: 'scheduleDate', header: 'Scheduled', size: 160 },
  { accessorKey: 'totalNos', header: 'Total nos', size: 110 },
  { accessorKey: 'nosProcessed', header: 'Processed', size: 110 },
  { accessorKey: 'dndCount', header: 'DND', size: 90 },
  { accessorKey: 'pulses', header: 'Pulses', size: 100 },
  { accessorKey: 'connectedCalls', header: 'Connected', size: 110 },
  { accessorKey: 'dtmfCount', header: 'DTMF', size: 90 },
  { accessorKey: 'dtmf1Count', header: 'DTMF1', size: 90 },
  { accessorKey: 'dtmf2Count', header: 'DTMF2', size: 90 },
  { accessorKey: 'retryCount', header: 'Retries', size: 100 },
  { accessorKey: 'autoRetryCount', header: 'Auto retry', size: 110 },
  { accessorKey: 'smsCount', header: 'SMS', size: 90 },
  { accessorKey: 'ttsCount', header: 'TTS', size: 90 },
  // { accessorKey: 'parentId', header: 'Parent ID', size: 110 },
  // { accessorKey: 'sParentId', header: 'S Parent', size: 110 },
  {
    accessorKey: 'hasWebhook',
    header: 'Webhook Log',
    size: 120,
    cell: ({ row }) => (row.original.hasWebhook === '1' ? 'Yes' : 'No'),
  },
  { accessorKey: 'webhookCount', header: 'Webhook Count', size: 130 },
  { accessorKey: 'webhookSuccessCount', header: 'Webhook Success Count', size: 170 },
  { accessorKey: 'webhookFailedCount', header: 'Webhook Failed Count', size: 160 },
  { accessorKey: 'retryWebhookCount', header: 'Retry Webhook Count', size: 160 },
];
